export default __webpack_public_path__ + "static/media/Flag of Democratic Republic of the Congo.2245486f.gif";